import { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';

/**
 * Banner de mise à jour PWA.
 *
 * Écoute `gs:sw-update-available` (émis par registerSW.ts quand un nouveau SW est prêt)
 * et dispatch `gs:sw-update-request` quand l'utilisateur clique sur « Activer maintenant ».
 *
 * Le SW n'est PAS activé automatiquement (skipWaiting=false côté vite.config) — l'utilisateur
 * consent explicitement au reload pour éviter de perdre un état de formulaire en cours.
 */
export function PwaUpdateBanner() {
  const [needsUpdate, setNeedsUpdate] = useState(false);
  const [activating, setActivating] = useState(false);

  useEffect(() => {
    const onUpdate = () => setNeedsUpdate(true);
    window.addEventListener('gs:sw-update-available', onUpdate);
    return () => window.removeEventListener('gs:sw-update-available', onUpdate);
  }, []);

  if (!needsUpdate) return null;

  const handleActivate = () => {
    setActivating(true);
    window.dispatchEvent(new CustomEvent('gs:sw-update-request'));
  };

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex flex-wrap items-center justify-between gap-3 border-b border-blue-200 bg-blue-50 px-4 py-2 text-sm text-slate-700"
    >
      <div className="flex items-center gap-2">
        <RefreshCw className="h-4 w-4 text-blue-500" aria-hidden="true" />
        <span>Une nouvelle version du hub est prête.</span>
      </div>
      <button
        type="button"
        onClick={handleActivate}
        disabled={activating}
        className="touch-manipulation rounded-md bg-blue-500 px-3 py-1 font-medium text-white transition-colors hover:bg-blue-600 disabled:cursor-wait disabled:opacity-70"
      >
        {activating ? 'Activation…' : 'Activer maintenant'}
      </button>
    </div>
  );
}

export default PwaUpdateBanner;
